import { useEffect, useContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Roles } from 'contexts/Roles.context';

/**
 * Component that sets Datadog RUM user context when authentication data is available.
 * Must be rendered within the RolesProvider to access user information.
 */
const DatadogUserTracker = () => {
  const { userInfo, isUserInfoLoading } = useContext(Roles);

  useEffect(() => {
    const user = userInfo;
    if (user?.userId) {
      const userName = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : undefined;

      const userContext = {
        id: user.userId,
        email: user.email,
        ...(userName && { name: userName }),
      };

      datadogRum.setUser(userContext);
    }
  }, [userInfo, isUserInfoLoading]);

  return null;
};

export default DatadogUserTracker;
